import { MarkdownViewer } from '@/business-components/markdown-viewer/MarkdownViewer';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { useEnvConfigModelStore } from '@/models/env-config/envConfig';
import { Modal } from 'aui';
import { useMemo } from 'react';

type TProps = {
  visible?: boolean;
  onCancel: () => void;
};

export function VibeCodingViaMCPModal(props: TProps) {
  const { visible, onCancel } = props;
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const appLowerName = useEnvConfigModelStore((x) => x.APP_NAME_LOWER);
  const appName = useEnvConfigModelStore((x) => x.APP_NAME);
  const onlineId = useDocsDataModelStore((x) => x.docsIdTypeData.onlineId);
  const title = useDocsDataModelStore((x) => x.docsBaseConfig.title);

  const serverName = useMemo(() => {
    const defaultName = `${title} - ${clientI18n('docsSite.enableVibeCodingViaMCP.suffix')}`;
    if (defaultName.length <= 24) {
      return defaultName;
    }

    if (title?.length && title.length <= 24) {
      return title;
    }
    return `${appLowerName}-site-${onlineId}`;
  }, [title, appLowerName, onlineId, clientI18n]);

  return (
    <Modal
      open={visible}
      title={clientI18n('docsSite.enableVibeCodingViaMCP.modal.title')}
      onCancel={onCancel}
      destroyOnClose
      size={640}
      footer={null}
    >
      <MarkdownViewer
        value={clientI18n('docsSite.enableVibeCodingViaMCP.modal.description', {
          appName: appName,
          appNameLower: appLowerName,
          appNameUpper: appName.toUpperCase(),
          docsSiteId: onlineId.toString(),
          serverName,
        })}
        enableHeaderPlugin={false}
        inDocView={false}
      />
    </Modal>
  );
}
